import { apiClient } from '@/core/api/client';
import type { ChatResponsePayload } from '@/core/services/chatService';

type CareContextPayload = {
  session_id: string;
  care_stage_id: string;
};

type JourneySummaryResponse = {
  session_id?: string;
  care_stage_id?: string;
  data?: Partial<CareContextPayload>;
  result?: Partial<CareContextPayload>;
  journey_summary?: Partial<CareContextPayload>;
};

function getCareContext(responseData: JourneySummaryResponse): CareContextPayload | null {
  const candidates = [
    responseData,
    responseData.data,
    responseData.result,
    responseData.journey_summary,
  ];

  for (const payload of candidates) {
    if (payload?.session_id && payload.care_stage_id) {
      return {
        session_id: payload.session_id,
        care_stage_id: payload.care_stage_id,
      };
    }
  }
  return null;
}

export async function ensureFpQaJourneySummary(
  sessionId: string,
): Promise<void> {
  const { data: journeyPayload } = await apiClient.get(
    '/navigator/generate-journey-summary',
    { params: { session_id: sessionId } },
  );
  const { data: responseData } = await apiClient.post<JourneySummaryResponse>(
    '/care-engine/journey-summary',
    journeyPayload,
  );
  const careContext = getCareContext(responseData);
  if (careContext) {
    await apiClient.post('/resources/store-care-context', careContext);
  }
}

export function summaryBulletsFromClassification(
  responseData: ChatResponsePayload,
): string[] {
  const summary = responseData.classification?.summary?.trim() ?? '';
  return summary
    ? summary
        .split(/\n+/)
        .map((line) => line.trim())
        .filter(Boolean)
    : [];
}
